import React from 'react';

const PageFooter = () => (
    <div className="text-right">
        <a href="https://www.neosvoc.com/">Powered by NeosVoc</a>
    </div>
);

export default PageFooter;
